import flags, { Flags } from "src/services/flags"

const useFlags = flags.useFlags

export type { Flags }
export default useFlags
